export default "__VITE_ASSET__6PpxKyCd__"